module.exports = __webpack_public_path__ + "img/explainer-2.eaebe0f5.svg";